import * as React from 'react'

import { Localized } from '../../localization/react'
import FormatTime, { FormatVariants as TimeFormatVariants, TimeValue } from '../FormatTime/FormatTime'

interface Props {
  variant: TimeFormatVariants
  start: TimeValue
  end: TimeValue
}

const TimeRange: React.FC<React.PropsWithChildren<Props>> = ({ variant, start, end }) => {
  if (start === end) {
    return <FormatTime variant={variant} value={start} />
  }

  return (
    <Localized
      id="time-range"
      params={{
        start: <FormatTime variant={variant} value={start} />,
        end: <FormatTime variant={variant} value={end} />,
      }}
    />
  )
}

export default TimeRange
